function setHalfSpacing() {
  const root = document.documentElement;
  const wrapper = document.querySelector('.container');
  if (!wrapper) return;

  const style = window.getComputedStyle(wrapper);
  const wrapperWidth = wrapper.offsetWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
  const usableWidth = document.documentElement.clientWidth;
  const result = Math.max((usableWidth - wrapperWidth) / 2, 0);

  root.style.setProperty('--half-spacing', result + 'px');
}

setHalfSpacing();

window.addEventListener('resize', setHalfSpacing);

document.addEventListener('shopify:section:load', setHalfSpacing);
document.addEventListener('shopify:section:reorder', setHalfSpacing);
document.addEventListener('shopify:section:unload', setHalfSpacing);

function initSectionVisible(el) {
  if (el.__visibleInited) return;

  el.__visibleInited = true;

  const enterRatio = el.dataset.visibleTop !== undefined ? parseFloat(el.dataset.visibleTop) : el.dataset.visible !== undefined ? parseFloat(el.dataset.visible) : 0.5;

  const leaveRatio = el.dataset.visibleBottom !== undefined ? parseFloat(el.dataset.visibleBottom) : enterRatio;

  let isActive = false;

  function checkVisible() {
    const rect = el.getBoundingClientRect();

    const visibleHeight = Math.max(
      0,
      Math.min(rect.bottom, window.innerHeight) -
      Math.max(rect.top, 0)
    );

    const visibleRatio = visibleHeight / rect.height;

    const isLoop = el.hasAttribute('data-visible-loop');

    // =========================
    // loop 模式
    // =========================
    if (isLoop) {
      // 进入
      if (!isActive && visibleRatio >= enterRatio) {
        el.classList.add('animation-start');

        playSequenceVideos();

        isActive = true;
      }

      // 离开
      if (isActive && visibleRatio <= leaveRatio) {
        el.classList.remove('animation-start');
        isActive = false;
      }

      return;
    }

    // =========================
    // 默认一次触发
    // =========================
    if (visibleRatio >= enterRatio) {
      el.classList.add('animation-start');

      playSequenceVideos();

      removeEvents();
    }
  }

  function playSequenceVideos() {
    if (el.__videoStarted && !el.hasAttribute('data-visible-loop')) return;

    el.__videoStarted = true;

    const videos = el.querySelectorAll('.scroll-sequence-video');

    if (!videos.length) return;

    // reset
    videos.forEach((video, index) => {
      video.pause();
      video.currentTime = 0;

      if (index === 0) {
        video.style.display = '';
      } else {
        video.style.display = 'none';
      }

      video.onended = null; // ⚠ 防重复绑定
    });

    if (videos.length === 1) {
      const video = videos[0];

      video.play().catch(() => { });

      return;
    }

    const firstVideo = videos[0];
    const secondVideo = videos[1];

    firstVideo.play().catch(() => { });

    firstVideo.onended = () => {
      firstVideo.style.display = 'none';

      secondVideo.style.display = '';

      secondVideo.play().catch(() => { });
    };
  }

  let ticking = false;

  function onScroll() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(() => {
      checkVisible();

      ticking = false;
    });
  }

  function removeEvents() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
  }

  // 初次检测
  checkVisible();

  // 后续监听
  window.addEventListener('scroll', onScroll, {
    passive: true
  });

  window.addEventListener('resize', onScroll);
}

function initBgVideoScale(el) {
  if (el.__bgVideoInited) return;

  el.__bgVideoInited = true;

  const video = el.querySelector('[data-scroll-video]');

  if (!video) return;

  const MIN_SCALE = 0.65;
  const MAX_SCALE = 1;

  let ticking = false;

  function update() {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight;

    const distance = rect.top;

    // =========================
    // ① scale 逻辑
    // =========================

    let scale;

    if (distance <= 0) {
      scale = MAX_SCALE;
    } else if (distance >= vh) {
      scale = MIN_SCALE;
    } else {
      const progress = 1 - distance / vh;

      const eased = progress * progress * (3 - 2 * progress);

      scale = MIN_SCALE + eased * (MAX_SCALE - MIN_SCALE);
    }

    video.style.transform = `scale(${scale})`;
    video.style.transformOrigin = 'center center';
  }

  function onScroll() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  }

  // 初始执行一次
  update();

  // 绑定 scroll
  window.addEventListener('scroll', onScroll, {
    passive: true
  });

  window.addEventListener('resize', onScroll);
}

function initVideoPopup(el) {
  if (el.__videoPopup) return;

  el.__videoPopup = true;

  el.addEventListener("click", function (event) {
    event.preventDefault();

    const button = el.matches('a[id^="b_"]') ? el : el.closest('a[id^="b_"]');
    if (!button) return;

    const cleanId = button.id.replace(/^b_/, "");
    const popupId = `video-popup-${cleanId}`;
    const oldPopup = document.getElementById(popupId);

    function lockScroll() {
      document.documentElement.style.overflow = "hidden";
    }

    function unlockScroll() {
      document.documentElement.style.overflow = "";
    }

    function openPopup(popup) {
      const video = popup.querySelector("video");

      popup.style.display = "block";
      lockScroll();

      if (video) {
        video.pause();
        video.currentTime = 0;
        video.play().catch(function () {});
      }
    }

    function closePopup(popup) {
      const video = popup.querySelector("video");

      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      popup.style.display = "none";
      unlockScroll();
    }

    function bindCloseEvent(popup) {
      if (popup.__closeInited) return;

      popup.__closeInited = true;

      popup.addEventListener("click", function (e) {
        if (e.target.classList.contains("custom-video-popup-mask")) {
          closePopup(popup);
        }
      });
    }

    if (oldPopup) {
      bindCloseEvent(oldPopup);
      openPopup(oldPopup);
      return;
    }

    const template = document.getElementById(`tmp-video-${cleanId}`);
    if (!template) return;

    const video = template.content.querySelector("video");
    if (!video) return;

    const popup = document.createElement("div");
    popup.id = popupId;
    popup.className = "custom-video-popup-mfp";
    popup.innerHTML = `
      <div class="custom-video-popup-mask"></div>
      <div class="custom-video-popup-content">
        <div class="custom-video-popup-media"></div>
      </div>
    `;

    const clonedVideo = video.cloneNode(true);
    clonedVideo.setAttribute("autoplay", "autoplay");

    popup.querySelector(".custom-video-popup-media").appendChild(clonedVideo);
    document.body.appendChild(popup);

    bindCloseEvent(popup);
    openPopup(popup);
  });
}

function initScroll(el) {
  if (el.__initScroll) return;
  el.__initScroll = true;

  const wrapper = el.querySelector('.custom-scroll-wrapper');
  const items = el.querySelectorAll('.custom-scroll-item');
  const prevButton = el.querySelector('.custom-scroll-prev');
  const nextButton = el.querySelector('.custom-scroll-next');

  if (!wrapper || !items.length) return;

  const perPage = Number(el.dataset.perPage) || 4;
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const canMouseDrag = el.hasAttribute('data-drag') || isMobile;

  let currentPage = 0;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function getMaxScrollLeft() {
    return Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
  }

  function getMaxPage() {
    return Math.max(0, Math.ceil(items.length / perPage) - 1);
  }

  function getItemLeft(item) {
    return item.getBoundingClientRect().left - wrapper.getBoundingClientRect().left + wrapper.scrollLeft;
  }

  function getScrollLeft(page) {
    const maxPage = getMaxPage();

    if (page >= maxPage) {
      return getMaxScrollLeft();
    }

    const targetItem = items[page * perPage];

    if (!targetItem) {
      return getMaxScrollLeft();
    }

    return clamp(getItemLeft(targetItem), 0, getMaxScrollLeft());
  }

  function getClosestPage() {
    const maxPage = getMaxPage();
    const maxScrollLeft = getMaxScrollLeft();

    if (wrapper.scrollLeft >= maxScrollLeft - 1) {
      return maxPage;
    }

    let closestPage = 0;
    let closestDistance = Infinity;

    for (let page = 0; page <= maxPage; page++) {
      const distance = Math.abs(wrapper.scrollLeft - getScrollLeft(page));

      if (distance < closestDistance) {
        closestDistance = distance;
        closestPage = page;
      }
    }

    return closestPage;
  }

  function updateButtons() {
    const maxPage = getMaxPage();

    if (prevButton) {
      prevButton.disabled = currentPage <= 0;
    }

    if (nextButton) {
      nextButton.disabled = currentPage >= maxPage;
    }
  }

  function goToPage(page) {
    const maxPage = getMaxPage();

    currentPage = clamp(page, 0, maxPage);

    wrapper.scrollTo({
      left: getScrollLeft(currentPage),
      behavior: 'smooth'
    });

    updateButtons();
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      goToPage(currentPage - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      goToPage(currentPage + 1);
    });
  }

  if (canMouseDrag) {
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    function stopDrag(e) {
      if (!isDragging) return;

      isDragging = false;
      wrapper.classList.remove('is-dragging');

      currentPage = getClosestPage();
      updateButtons();

      if (e && wrapper.hasPointerCapture(e.pointerId)) {
        wrapper.releasePointerCapture(e.pointerId);
      }
    }

    wrapper.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;

      isDragging = true;
      startX = e.clientX;
      startScrollLeft = wrapper.scrollLeft;

      wrapper.classList.add('is-dragging');
      wrapper.setPointerCapture(e.pointerId);
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (!isDragging) return;

      const moveX = e.clientX - startX;
      wrapper.scrollLeft = clamp(startScrollLeft - moveX, 0, getMaxScrollLeft());
    });

    wrapper.addEventListener('pointerup', stopDrag);
    wrapper.addEventListener('pointercancel', stopDrag);
    wrapper.addEventListener('lostpointercapture', stopDrag);

    wrapper.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  wrapper.addEventListener('scroll', function () {
    currentPage = getClosestPage();
    updateButtons();
  });

  updateButtons();
}

function imageInteractive(el) {
  if (el.__imageInteractive) return;
  el.__imageInteractive = true;

  const infos = el.querySelectorAll('.custom-interactive-image-info');
  const main = el.querySelector('.custom-interactive-image-main');

  infos.forEach((info) => {
    info.addEventListener('mouseenter', () => {
      const id = info.dataset.id;
      if (!id || !main) return;

      const target = Array.from(main.querySelectorAll('[id]')).find((item) => item.id === id);

      if (target) {
        target.classList.add('active');
      }

      infos.forEach((item) => {
        if (item !== info) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    });

    info.addEventListener('mouseleave', () => {
      const id = info.dataset.id;
      if (!id || !main) return;

      const target = Array.from(main.querySelectorAll('[id]')).find((item) => item.id === id);

      if (target) {
        target.classList.remove('active');
      }

      infos.forEach((item) => {
        item.classList.remove('active');
      });
    });
  });
}

function numberCount(el) {
  if (el.__numberCount) return;
  el.__numberCount = true;

  const target = Number(el.dataset.count);
  const duration = Number(el.dataset.duration) || 1500;
  const decimals = Number(el.dataset.decimals) || 0;
  const prefix = el.dataset.prefix || '';
  const suffix = el.dataset.suffix || '';

  function formatNumber(num) {
    return (
      prefix +
      num.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      suffix
    );
  }

  function startCount() {
    const startTime = performance.now();

    function update(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      const current = target * easeProgress;

      el.textContent = formatNumber(current);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = formatNumber(target);
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      startCount();
      observer.disconnect();
    }
  }, {
    threshold: 0.3
  });

  observer.observe(el);
}

function videoHover(el) {
  if (el.__videoHover) return;
  el.__videoHover = true;

  const items = el.querySelectorAll('.custom-video-hover-inner');
  if (!items.length) return;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function getVideo(item) {
    return item.querySelector('video');
  }

  function pauseVideo(video, reset) {
    if (!video) return;

    video.pause();

    if (reset) {
      video.currentTime = 0;
    }
  }

  function playVideo(video, loop, muted) {
    if (!video) return;

    video.loop = loop;
    video.muted = muted;
    video.playsInline = true;

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseOtherVideos(currentVideo) {
    items.forEach(function (item) {
      const video = getVideo(item);

      if (video && video !== currentVideo) {
        pauseVideo(video, true);
      }
    });
  }

  items.forEach(function (item) {
    const video = getVideo(item);
    if (!video) return;

    let startX = 0;
    let startY = 0;
    let hasMoved = false;

    item.addEventListener('mouseenter', function () {
      if (isMobile()) return;

      pauseOtherVideos(video);

      playVideo(video, true, false);
    });

    item.addEventListener('mouseleave', function () {
      if (isMobile()) return;

      pauseVideo(video, false);
    });

    item.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;

      startX = e.clientX;
      startY = e.clientY;
      hasMoved = false;
    });

    item.addEventListener('pointermove', function (e) {
      if (!isMobile()) return;

      const moveX = Math.abs(e.clientX - startX);
      const moveY = Math.abs(e.clientY - startY);

      if (moveX > 8 || moveY > 8) {
        hasMoved = true;
      }
    });

    item.addEventListener('click', function () {
      if (!isMobile()) return;
      if (hasMoved) return;

      pauseOtherVideos(video);

      if (video.paused) {
        playVideo(video, false, false);
      } else {
        pauseVideo(video, false);
      }
    });
  });
}

const watchList = [
  {
    selector: '[data-scroll-trigger]',
    handler: initSectionVisible,
    flag: '__visibleInited'
  },
  {
    selector: '[data-scroll-scale]',
    handler: initBgVideoScale,
    flag: '__bgVideoInited'
  },
  {
    selector: '.custom-video-popup',
    handler: initVideoPopup,
    flag: '__videoPopup'
  },
  {
    selector: '.custom-scroll',
    handler: initScroll,
    flag: '__initScroll'
  },
  {
    selector: '.custom-interactive-image',
    handler: imageInteractive,
    flag: '__imageInteractive'
  },
  {
    selector: '.custom-count-number',
    handler: numberCount,
    flag: '__numberCount'
  },
  {
    selector: '.custom-video-hover',
    handler: videoHover,
    flag: '__videoHover'
  }
];

// 初次加载
watchList.forEach(item => {
  document.querySelectorAll(item.selector).forEach(node => {
    if (item.flag && node[item.flag]) return;
    item.handler(node);
  });
});

// 统一 MutationObserver 监听
let moTimer = null;

const observer = new MutationObserver(() => {
  clearTimeout(moTimer);
  moTimer = setTimeout(() => {
    watchList.forEach(item => {
      document.querySelectorAll(item.selector).forEach(node => {
        if (item.flag && node[item.flag]) return;
        item.handler(node);
      });
    });
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});